document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('[data-jye-stores]');
  if (!container) return;

  const filters = container.querySelectorAll('[data-filter]');
  const cards = container.querySelectorAll('.jye-store-card');
  const countDisplay = container.querySelector('[data-store-count]');
  const emptyMessage = container.querySelector('[data-empty-message]');

  let currentFilter = 'todas';

  function updateStatus() {
    // Definimos hora actual en zona horaria de Colombia
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Bogota',
      hour12: false,
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    });

    const parts = formatter.formatToParts(new Date());
    let weekday = '';
    let hour = 0;
    let minute = 0;

    parts.forEach(part => {
      if (part.type === 'weekday') weekday = part.value.toLowerCase();
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });

    // Mapeo de días para coincidir con los atributos de datos (lun, mar, mie, etc)
    const dayMap = {
      'mon': 'lun',
      'tue': 'mar',
      'wed': 'mie',
      'thu': 'jue',
      'fri': 'vie',
      'sat': 'sab',
      'sun': 'dom'
    };
    
    const currentDay = dayMap[weekday];
    const currentTimeVal = hour + (minute / 60);

    cards.forEach(card => {
      const statusEl = card.querySelector('[data-status]');
      if (!statusEl) return;

      const hoursString = card.getAttribute(`data-${currentDay}`);
      if (!hoursString || !hoursString.includes('|')) {
        statusEl.textContent = 'Cerrado';
        statusEl.setAttribute('data-is-open', 'false');
        card.setAttribute('data-is-open-now', 'false');
        return;
      }

      const [openStr, closeStr] = hoursString.split('|');
      const openParts = openStr.split(':');
      const closeParts = closeStr.split(':');

      const openVal = parseInt(openParts[0], 10) + (parseInt(openParts[1] || '0', 10) / 60);
      const closeVal = parseInt(closeParts[0], 10) + (parseInt(closeParts[1] || '0', 10) / 60);

      let isOpen = false;
      if (closeVal > openVal) {
        // Horario normal (ej 09:00 a 20:00)
        isOpen = (currentTimeVal >= openVal && currentTimeVal < closeVal);
      } else {
        // Horario cruzando medianoche
        isOpen = (currentTimeVal >= openVal || currentTimeVal < closeVal);
      }

      if (isOpen) {
        statusEl.textContent = 'Abierto';
        statusEl.setAttribute('data-is-open', 'true');
        card.setAttribute('data-is-open-now', 'true');
      } else {
        statusEl.textContent = 'Cerrado';
        statusEl.setAttribute('data-is-open', 'false');
        card.setAttribute('data-is-open-now', 'false');
      }
    });
  }

  function applyFilter(filterValue) {
    currentFilter = filterValue;
    let visibleCount = 0;

    // Activar botón
    filters.forEach(btn => {
      if (btn.getAttribute('data-filter') === filterValue) {
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.setAttribute('aria-pressed', 'false');
      }
    });

    // Mostrar/Ocultar tarjetas
    cards.forEach(card => {
      const cardCity = card.getAttribute('data-city');
      const isOpenNow = card.getAttribute('data-is-open-now');

      let shouldShow = false;
      if (filterValue === 'todas') {
        shouldShow = true;
      } else if (filterValue === 'abiertas-ahora') {
        shouldShow = (isOpenNow === 'true');
      } else {
        shouldShow = (cardCity === filterValue);
      }

      if (shouldShow) {
        card.hidden = false;
        visibleCount++;
      } else {
        card.hidden = true;
      }
    });

    // Actualizar conteo
    if (visibleCount === 1) {
      countDisplay.textContent = '1 tienda';
    } else {
      countDisplay.textContent = `${visibleCount} tiendas`;
    }

    // Mensaje vacío
    if (visibleCount === 0) {
      emptyMessage.hidden = false;
    } else {
      emptyMessage.hidden = true;
    }
  }

  // Event Listeners
  filters.forEach(btn => {
    btn.addEventListener('click', function() {
      applyFilter(this.getAttribute('data-filter'));
    });
  });

  // Inicializar
  updateStatus();
  applyFilter('todas');

  // Actualizar status cada 1 minuto (por si el usuario deja la página abierta)
  setInterval(updateStatus, 60000);
});
